import React from "react";
import { Link } from "react-router-dom";
import { Clock, LogOut, Trash2 } from "lucide-react";
import { useAuth } from "../context/AuthContext";

export default function PendingApproval() {
  const { user, logout } = useAuth();
  const handleLogout = async () => { await logout(); window.location.href = "/"; };

  return (
    <div className="min-h-[calc(100vh-4rem)] flex items-center justify-center px-6 py-16">
      <div className="max-w-xl w-full border border-[#0F0F0F] p-10">
        <div className="label-eyebrow flex items-center gap-1.5">
          <Clock className="w-3 h-3 text-[var(--brand-primary)]" /> Account pending review
        </div>
        <h1 className="font-display font-black text-4xl mt-3 tracking-tight">Hold tight, {user?.name?.split(" ")[0] || "there"}.</h1>
        <p className="mt-4 text-base leading-relaxed">
          Your recruiter account for <strong>{user?.company_name || "your company"}</strong> is awaiting Owner review.
          You'll receive an email at <span className="font-mono text-sm">{user?.email}</span> the moment it's approved.
        </p>
        <p className="mt-4 text-sm text-[#5C5C5C]">
          Until then, the recruiter dashboard, pipeline, and billing are not available — no payment will be taken
          while you're pending.
        </p>

        <div className="mt-8 grid gap-2 text-sm">
          <div className="border border-[#E2E0D8] p-4">
            <div className="label-eyebrow">What you can do now</div>
            <ul className="mt-2 list-disc pl-5 space-y-1 text-[#3a3a3a]">
              <li>Browse <Link to="/jobs" className="underline hover:text-[var(--brand-primary)]">live roles</Link></li>
              <li>Update your profile and 2FA from <Link to="/settings" className="underline hover:text-[var(--brand-primary)]">Settings</Link></li>
              <li>Need to follow up? Email <a className="underline hover:text-[var(--brand-primary)]" href="mailto:admin@oceanash.org">admin@oceanash.org</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-8 flex gap-3 flex-wrap">
          <button onClick={handleLogout} data-testid="pending-logout" className="btn-ink text-sm">
            <LogOut className="w-4 h-4" /> Sign out
          </button>
          <Link to="/settings" data-testid="pending-settings" className="btn-ghost text-sm inline-flex items-center gap-1.5">
            <Trash2 className="w-4 h-4" /> Manage account
          </Link>
        </div>
      </div>
    </div>
  );
}
